import React from 'react';
import * as d3 from 'd3';
import PropTypes from 'prop-types';
import './custom-graph.css';
import Translation from '../../Translation'
import { utils } from '../../config';

export class CustomGraph extends React.Component {
    constructor(props) {
        super(props);
        this.comId = (Math.random() * 1000000<<0).toString(16);

        this.width = this.props.size.width || 600;
        this.timer = null;
        this.height = this.props.size.height || 400;

        this.state = {
            lines: this.props.lines,
            axis: props.axis
        };

        this.higlightLine = this.higlightLine.bind(this);
        this.renderChart = this.renderChart.bind(this);
        this.addClass = ((elem, newClass) => {
            let isIE11 = document.body.className.indexOf('ie11') > -1;
            if(isIE11) {
                let currentClass = elem.getAttribute('class');
                elem.setAttribute('class', currentClass + ' '+ newClass)
            } else {
                elem.classList.add(newClass);
            }
        })
        this.removeClass = ((elem, newClass) => {
            let isIE11 = document.body.className.indexOf('ie11') > -1;
            if(isIE11) {
                let currentClass = elem.getAttribute('class');
                currentClass = currentClass.replace(newClass, '');
                elem.setAttribute('class', currentClass);
            } else {
                elem.classList.remove(newClass);
            }
        })
    }
  
    componentDidMount() {
        this.renderChart();
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        var shouldUpdate = false;
        var obj = {};
        if(newProps && !newProps.axis.x.min ) {
            return;
        }
        if (this.state.lines !== newProps.lines) {
            obj.lines = newProps.lines;
            shouldUpdate = true;
        }

        if (this.state.axis !== newProps.axis) {
            obj.axis = newProps.axis;
            shouldUpdate = true;
        }

        if (newProps.reload !== this.props.reload) {
            obj.reload = newProps.reload;
            shouldUpdate = true;
        }
        
        if (shouldUpdate) {
            this.setState(obj, function() {
                this.renderChart();
            });
        }
    }

   
    lineFunc(xRange, yRange, d) {
        let axis = this.state.axis;
        return d3.line()
            .x(function(d) {
                return xRange(Math.max(Math.min(axis.x.max, d.x), axis.x.min));
            })
            .y(function(d) {
                return yRange(Math.max(Math.min(axis.y.max, d.y), axis.y.min));
            })
            .curve(d3.curveLinear)(d); 
    }


    renderDotsAndTexts(vis, loc, xRange, yRange,color, isTop) {
        let axis = this.state.axis;
        let yPad = isTop ? -10 : 15;
        if (loc.x === 0 && loc.y === 0) {
            return;
        }
        vis.append('svg:text')
            .attr('class', 'visualisations--line-text')
            .attr('text-anchor', 'middle')
            .attr('x', xRange(Math.max(Math.min(axis.x.max, loc.x), axis.x.min)))
            .attr('y', yRange(Math.max(Math.min(axis.y.max, loc.y), axis.y.min)) + yPad)
            .attr('fill', '#000')
            .attr('font-family', '"din-2014",Arial,sans-serif')
            .attr('font-size', '12px')
            .attr('font-weight', 'bold')
            .text(loc.x + ', ' + loc.y);
            
        vis.append('svg:circle')
            .attr('class', 'visualisations--line-dot')
            .attr('cx',  xRange(Math.max(Math.min(axis.x.max, loc.x), axis.x.min)))
            .attr('cy', yRange(Math.max(Math.min(axis.y.max, loc.y), axis.y.min)))
            .attr('font-family', '"din-2014",Arial,sans-serif')
            .attr('font-size', '12px')
            .attr('font-weight', 'bold')
            .attr('fill', color)
            .attr('r', 5);
    }

    renderLine(vis, item, xRange, yRange) {
        vis.append('svg:path')
            .attr('d', this.lineFunc(xRange, yRange, item.lineData))
            .attr('class', 'visualisations--line ')
            .attr('stroke', item.color)
            .attr('stroke-width', 4)

            .attr('fill', 'none');
    }

    renderTargetLine(vis, item, xRange, yRange) {
        let axis = this.state.axis;
        if (!item.target || (item.target[0].y === 0 && item.target[1].y ===0)) {
            return;
        }
        let loc = item.target[0];
        vis.append('svg:path')
            .attr('d', this.lineFunc(xRange, yRange, item.target))
            .attr('class', 'visualisations--lines')
            .attr('stroke', '#000')
            .attr('stroke-width', 4)
            .attr('stroke-dasharray', '5,5')
            .attr('fill', 'none');

        vis.append('svg:text')
            .attr('class', 'visualisations--lines-text')
            .attr('text-anchor', 'end')
            .attr('x', xRange(Math.max(Math.min(axis.x.max, loc.x), axis.x.min)))
            .attr('y', yRange(Math.max(Math.min(axis.y.max, loc.y), axis.y.min)))
            .attr('fill', '#000')
            .attr('font-family', '"din-2014",Arial,sans-serif')
            .attr('font-size', '12px')
            .attr('dx', '-0.7em')
            .attr('dy', '0.3em')
            .attr('font-weight', 'normal')
            .text(utils.getTranslationText('lbl_target', 'Target') + ': ' + loc.y);
    }
   
    renderChart() {
        var svg = d3.select('#vis'+this.comId);
        var margin = { top: 20, right: 20, bottom: 30, left: 40 };
        var lines = this.state.lines;
        var axis = this.state.axis;

        var width, height;
        width = this.width - margin.left - margin.right;
        height = this.height - margin.top - margin.bottom;

        if (!lines) {
            return;
        }


        svg.attr("width", this.width)
            .attr("height", this.height);

        svg.selectAll('*').remove();

        var x = d3.scaleLinear()
            .domain([axis.x.min, axis.x.max])
            .range([0, width])
            .nice(5);

        var y = d3.scaleLinear()
            .domain([axis.y.min, axis.y.max])
            .range([height, 0])
            .nice(5);


        //creates gridlines
        var g = svg.append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
            .attr("class", "grid")
            .call(
                d3.axisRight(y)
                .ticks(5)
                .tickSize(width)
                .tickFormat("")
            ).attr("color", "#d7cfcf");

        g.append("g")
            .attr("transform", "translate(0," + height + ")")  
            .attr("class", "grid") 
            .call(d3.axisBottom(x)
                .ticks(5)
                .tickSize(-height)
                .tickFormat("")
            ).attr("color", "#d7cfcf");
       
        //creates axis labels and scale values
        g.append("g")
            .attr("transform", "translate(0," + height + ")")
            .attr("color", "#000")
            .call(
                d3.axisBottom(x)
                    .ticks(5)
            )
            .append("text")
            .attr("fill", "#000")
            .attr("font-size", '11px')
            .attr("y", -7)
            .attr("x", width)
            .attr("dx", "-0.7em")
            .attr("text-anchor", "end")
            .text(axis.x.name);
        
        g.append("g")
        .attr("color", "#000")
            .call(
                d3.axisLeft(y)
                    .ticks(5)
            )
            .append("text")
            .attr("fill", "#000")
            .attr("font-size", '11px')
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", "0.71em")
            .attr("dx", "-0.7em")
            .attr("text-anchor", "end")
            .text(axis.y.name);

        const lineGroup = g.append('g')
            .attr('class','visualisation--line-group');
        this.state.lines.map((item) => {
            const lineGroup = g.append('g')
            .attr('title', item.title)
            .attr('class','visualisations--line-group');

            this.renderLine(lineGroup, item, x, y);

            item.lineData.map((loc, idx) => {
                this.renderDotsAndTexts(lineGroup, loc, x, y, item.color, idx);
                return true;
            });
            return true;
        });
        if (this.state.lines.length) {
            this.renderTargetLine(lineGroup, this.state.lines[this.state.lines.length-1], x, y);
        }
        
  
    }

    higlightLine(e, enter) {
        const lineId = e.currentTarget.querySelector('.visualisation-info--items-title').textContent;
        let visualGraphElem = '.visualisations.graph-large';
        const lineGroup = document.querySelector(visualGraphElem + ' g.visualisations--line-group[title="' + lineId +'"]');
        const otherLineGroup = document.querySelectorAll(visualGraphElem + ' g.visualisations--line-group');
        if (this.timer) {
            clearTimeout(this.timer);
        }
        setTimeout(()=> {
            let _this = this;
            if (enter) {
                otherLineGroup.forEach(function(item) {
                    _this.addClass(item, 'lowopacity');
                })
                _this.addClass(lineGroup, 'highlight');
            } else {
                _this.removeClass(lineGroup, 'highlight');
                otherLineGroup.forEach(function(item) {
                    _this.removeClass(item, 'lowopacity');
                })
            }
        }, 100);
    }
  
    render() {
        return ( 
            <div className="vis">
                <div className="wrapper">
                <svg id={'vis'+this.comId} className={'visualisations graph-large'} width={this.width} height={this.height + 40}></svg>
                    <div className="visualisation-infobox">
                        <div className="visualisation-info">
                            {!this.props.isCarbon && <div className="visualisation-info--items" >
                                <span className="visualisation-info--items-color" style={{backgroundColor: '#000'}}></span>
                                <h3 className="visualisation-info--items-title"><Translation labelName="lbl_target" defaultText="Target"/></h3>
                            </div>
                            }
                            {this.state.lines.map((line,i)=>{
                                return (
                                    <div className="visualisation-info--items" onMouseOver={e=> this.higlightLine(e, true)} onMouseOut={e => this.higlightLine(e, false)} key={i}>
                                        <span className="visualisation-info--items-color" style={{backgroundColor: line.color}}></span>
                                        <h3 className="visualisation-info--items-title">{line.title}</h3>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="visualisations-info visualisations--title">
                            {this.props.title}
                            <div className="visualisations-info--logo">
                                <img
                                    width="60"
                                    src="./images/CelaneseLogo.png"
                                    alt="celanese logo"
                                    className="logo" />
                                <img
                                    width="120"
                                    src="./images/tow-plus-logo.png"
                                    alt="TowPlus logo"
                                    className="logo" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CustomGraph.propTypes = {
    size: PropTypes.object,
    lines: PropTypes.array.isRequired,
    axis: PropTypes.object,
    isCarbon: PropTypes.bool,
    title: PropTypes.string,
    assignClass: PropTypes.string,
    reload: PropTypes.bool
};

CustomGraph.defaultProps = {
    size: {width: 800, height: 400},
    axis: {x: {min: 0, max: 100, name: 'x-axis'}, y: {min: 0, max: 100, name: 'y-axis'}}
};


// WEBPACK FOOTER //
// ./src/components/custom-graph/index.js